import { action, computed, makeObservable, observable } from 'mobx';

import { IAccessibilityStore } from '../IAccessibilityStore';

export type FontSizeMultiplier = 1 | 1.18 | 1.28;

export class FontSizeStore implements IAccessibilityStore {
  fontSizeMultiplier: FontSizeMultiplier = 1;

  constructor() {
    makeObservable(this, {
      fontSizeMultiplier: observable,

      isDefaultFontSize: computed,
      isMediumFontSize: computed,
      isLargeFontSize: computed,

      setFontSizeMultiplier: action.bound,
      reset: action.bound,
    });
  }

  get isDefaultFontSize() {
    return this.fontSizeMultiplier === 1;
  }

  get isMediumFontSize() {
    return this.fontSizeMultiplier === 1.18;
  }

  get isLargeFontSize() {
    return this.fontSizeMultiplier === 1.28;
  }

  setFontSizeMultiplier(multiplier: FontSizeMultiplier) {
    this.fontSizeMultiplier = multiplier;
  }

  setFontSizeMedium = () => {
    this.setFontSizeMultiplier(1.18);
  };

  setFontSizeLarge = () => {
    this.setFontSizeMultiplier(1.28);
  };

  reset = () => {
    this.setFontSizeMultiplier(1);
  };
}
